import { DateTimeDisplay, StatusMessage } from "../../components/ui";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { useAuth0 } from "../../contexts/useAuthContext";
import { BureauCategory } from "../../components/alarms";
import { UltraCriticalAlarms } from "../../components/cards";
import { HomeGroupFilter } from "../../features/home/HomeGroupFilter";
import { useHomeGroups } from "../../features/home/useHomeGroups";
import { EMPTY_HOME_SITE_SCOPE, hasHomeSiteScope } from "../../features/home/homeGroupScope";

const Home = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const groups = useHomeGroups(isAuthenticated && !isLoading);
    const filter = <HomeGroupFilter options={groups.options} selectedIds={groups.selectedIds}
        loading={groups.groupsLoading} onChange={groups.changeSelection} />;
    const scoped = !!groups.selectedIds.length;
    const scopeEmpty = scoped && groups.scope && !hasHomeSiteScope(groups.scope);
    if (isLoading) {return null;}
    if (!isAuthenticated) {return <div>You are not logged in. Please log in to view this content.</div>;}
    return (
        <main><div className="container mb-2">
            <section className="page">
                <h2 className="heading__title heading__title--monitor">{groups.heading}</h2>
                <DateTimeDisplay />
                {groups.groupsError && <StatusMessage kind="error">{groups.groupsError}</StatusMessage>}
                <UltraCriticalAlarms />
                <div className="col-12-xs" id="monitor-active-alarms">
                    {groups.scopeLoading && <LoadingSpinner message="Loading CSH group sites…" />}
                    {groups.scopeError && <StatusMessage kind="error">{groups.scopeError}</StatusMessage>}
                    {scopeEmpty && <p>No sites are assigned to the selected CSH groups.</p>}
                    <BureauCategory initialCategory="active-not-ack" hideToolbar showSortSummary
                        siteScope={scoped ? groups.scope ?? EMPTY_HOME_SITE_SCOPE : null} useClientPagination={scoped}
                        tableHeaderActions={filter}
                        tableHeaderSubtitle={scoped ? <div className="group-results">Showing alarms for: <strong>{groups.summary}</strong></div> : null} />
                </div>
            </section>
        </div></main>
    );
};

export default Home;
